<template>
  <div class="wrap">
    <JNav :title="$t('签到')" />
    <div class="cont">
      <div class="userinfo_bar">
        <VanImage width="70" height="70" :src="$img(userInfo.userimg)" round>
          <VanImage slot="error" width="70" height="70" :src="require('@/assets/Img/myImg/MyOne.png')" round />
        </VanImage>
        <div class="level_bar">
          <div class="nickname">
            {{
              userInfo.username ? userInfo.username : $t("newAdd.noLoginUserName")
            }}
          </div>
          <div class="hr"></div>
          <div class="level">{{ userInfo.rank_title }}</div>
        </div>

        <div class="calendar_bar">
          <CheckIn v-model="times" :checkin="checked" :today="today" @checkIn="checkIn" :disabledClick="true" />
        </div>
      </div>
      <div class="rule_bar" v-html="rule"></div>
      <div class="submit_bar" :class="{ btn_checked: todayIsChecked() }" @click="handleCommit">
        {{ $t("My.Button.Two") }}
      </div>
    </div>
    <van-overlay :show="show" @click="show = false" class="overlay">
      <div class="overlay_cont" @click.stop>
        <img src="../../assets/new/mine/SignSuccess.png" alt="">
        <div class="overlay_title">{{ $t('恭喜') }}</div>
        <div class="overlay_titles">{{ $t('您已领取') }}</div>
        <div class="overlay_msg">{{ msg }}</div>
        <div class="btn" @click="show = false">{{ $t('My.Button.Two') }}</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { GET_CHECKINDATA, CHECK } from "@/api/checkin";
import CheckIn from "@/components/checkIn";
import JNav from "@/components/JNav"
import {
  NavBar,
  cell,
  icon,
  field,
  Dialog,
  Toast,
  Grid,
  GridItem,
  tabs,
  tab,
  Button,
  Image as VanImage,
  Calendar,
  Overlay
} from "vant";

export default {
  components: {
    NavBar,
    Calendar,
    [cell.name]: cell,
    [icon.name]: icon,
    [field.name]: field,
    [Toast.name]: Toast,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [tabs.name]: tabs,
    [tab.name]: tab,
    [Dialog.Component.name]: Dialog.Component,
    [Button.name]: Button,
    VanImage,
    CheckIn,
    JNav,
    [Overlay.name]: Overlay
  },
  data() {
    return {
      userInfo: {},
      checked: [],
      rule: "",
      times: {},
      today: new Date(),
      show: false,
      msg: ''
    };
  },
  watch: {
    times: {
      deep: true,
      handler({ year, month }) {
        if (year && month) {
          this.getChecked(year, month);
        }
      },
    },
  },
  created() {
    this.getUserInfo();
  },
  computed: {
    account() {
      return (this.userInfo || {}).userphone;
    },
  },
  mounted() {
  },
  methods: {
    getUserInfo() {
      Toast.loading();
      this.$api.getUserInfo((res) => {
        Toast.clear();
        this.userInfo = res;
      }, (err) => {
        Toast.clear();
      }
      );
    },
    todayIsChecked() {
      const hasNow = this.checked.filter(
        (item) =>
          this.$format(item, "yyyy-MM-dd") ===
          this.$format(new Date(this.today), "yyyy-MM-dd")
      );
      if (!!hasNow.length) {
        return true;
      }
      return false;
    },
    async handleCommit() {
      if (this.todayIsChecked()) return Toast(this.$t("todayChecked"));
      try {
        const res = await CHECK();
        await this.getChecked(this.times.year, this.times.month);
        this.msg = res.msg
        this.$nextTick(() => {
          this.show = true;
        })
        // Toast(res.msg);
      } catch (error) {
        Toast(error.msg)
      }
    },
    checkIn() { },
    async getChecked(year, month) {
      const res = await GET_CHECKINDATA(year, month);
      this.checked = res.lists || [];
      this.rule = res.rule || "";
      if (
        res.current_day &&
        res.current_day !== this.$format(this.today, "yyyy/MM/dd")
      ) {
        this.today = new Date(res.current_day);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@Color: var(--theme);
@Bc: var(--nav-background);

.wrap {
  min-height: 100vh;
  background: var(--bg);

  /deep/ [class*="van-hairline"]::after {
    border: none;
  }

  .cont {
    padding: 0 calc(13rem / 16) calc(13rem / 16);

    .userinfo_bar {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      background: @Bc;
      background-size: 100% 100%;
      @tradeinfo_height: calc(382rem / 16);
      @bottom: calc(-300rem / 16);
      padding: calc(24rem / 16) 0 calc(55rem / 16);
      margin-bottom: calc(15rem / 16 + @tradeinfo_height - (@tradeinfo_height + @bottom));

      .avatar {
        background-size: 100% 100%;
      }

      .level_bar {
        display: flex;
        justify-content: space-around;
        align-items: center;
        color: #fff;
        margin-top: calc(14rem / 16);
        margin-bottom: calc(20rem / 16);
        // font-family: PingFangSC-Medium;
        font-size: calc(15rem / 16);

        .hr {
          width: 1px;
          height: calc(22rem / 16);
          background: #fff;
          margin: 0 calc(16rem / 16);
        }
      }

      .calendar_bar {
        position: absolute;
        background: #fff;
        border-radius: calc(10rem / 16);
        padding: calc(12rem / 16) calc(2rem / 16) calc(12rem / 16);
        bottom: @bottom;
      }
    }

    .form_bar {
      margin: 0 calc(13rem / 16);
      padding: calc(13rem / 16);
      border-radius: calc(10rem / 16);
      background: #0271dc;

      .submission_bar {
        @height: calc(60rem / 16);
        height: @height;
        background: #fff;
        border-radius: calc(5rem / 16);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 calc(10rem / 16);

        .title {
          font-size: calc(12rem / 16);
          // color: #6e87a0;
          // font-family: PingFangSC-Medium;
          white-space: nowrap;
        }

        >.input {
          margin-left: calc(10rem / 16);
          flex-grow: 1;
          overflow: hidden;
          border-bottom: 1px solid #0271dc;
          display: flex;
          // align-items: center;
          align-items: flex-end;

          >input {
            border: none;
            height: calc(@height * 0.5);
            color: #0271dc;
          }
        }
      }

      .type_bar {
        padding: calc(15rem / 16) 0;
        display: flex;
        justify-content: space-between;

        >div {
          line-height: calc(35rem / 16);
          text-align: center;
          color: #fff;
          // font-family: PingFangSC-Medium;
          font-size: calc(12rem / 16);
          font-weight: normal;
          white-space: nowrap;
          padding: 0 calc(12rem / 16);
          border-radius: calc(5rem / 16);
        }

        .active {
          background: #fff;
          color: #0271dc;
        }
      }

      .textarea_wrap {
        position: relative;
        padding: calc(13rem / 16);
        background: #fff;
        border-radius: calc(5rem / 16);

        .hash_bar {
          background: #fff;
          height: calc(125rem / 16);
          border: none;
          width: 100%;
        }

        .btn_past {
          border-radius: 50%;
          @size: calc(50rem / 16);
          width: @size;
          line-height: @size;
          text-align: center;
          // background-color: #5a00ff;
          background-color: var(--theme);
          color: #fff;
          position: absolute;
          bottom: calc(13rem / 16);
          right: calc(13rem / 16);

          &:active {
            opacity: 0.8;
          }
        }
      }
    }

    .rule_bar {
      // background: #fff;
      // margin: calc(13rem / 16) 0;
      border-radius: calc(10rem / 16);
      padding: 0 calc(8rem / 16) calc(20rem / 16);
    }

    .submit_bar {
      background: linear-gradient(-90deg, #ff3a3e, #ff1e30);
      box-shadow: 0 5px 10px 0 rgba(255, 0, 16, 0.4);
      height: 52px;
      line-height: 52px;
      color: var(--light);
      font-size: calc(14rem / 16);
      text-align: center;
      border-radius: 10px;
    }
  }

  .btn_checked {
    color: var(--theme);
    background: rgb(206, 234, 255);
    font-weight: normal;
  }

  .overlay {
    display: flex;
    align-items: center;
    justify-content: center;

    &_cont {
      width: 70vw;
      border: 1px solid #FEE182;
      border-radius: 24px;
      background: #953535;
      padding: 0 20px 20px;

      img {
        height: 150px;
        width: 100%;
        margin-top: -40px;
        object-fit: contain;
        display: block;
      }

      .overlay_title {
        text-align: center;
        font-size: 16px;
        font-weight: 800;
        color: #fff;
        margin-top: 10px;
      }
      .overlay_titles {
        text-align: center;
        font-size: 16px;
        color: #fff;
        margin-top: 10px;
        line-height: 1;
      }

      .overlay_msg {
        margin-top: 3px;
        text-align: center;
        font-weight: bold;
        line-height: 1.5;
        background: linear-gradient(180deg, #FBE599 0%, #F9DB76 49%, #FBE699 72%, #EEB452 99%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
      }

      .btn {
        width: fit-content;
        margin: 0 auto;
        margin-top: calc(24rem / 16);
        padding: calc(10rem / 16) calc(50rem / 16);
        color: #7F1414;
        line-height: calc(20rem / 16);
        border-radius: 100px;
        font-size: calc(16rem / 16);
        background: linear-gradient(181deg, #FBE599 3%, #F9DB76 49%, #FBE699 70%, #EEB452 95%);
      }
    }
  }
}
</style>
